import { render, staticRenderFns } from "./ReportDebtor.vue?vue&type=template&id=0b74e0b6&scoped=true&"
import script from "./ReportDebtor.vue?vue&type=script&lang=js&"
export * from "./ReportDebtor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b74e0b6",
  null
  
)

export default component.exports